import { Button, Center, useToast } from '@chakra-ui/react';
import QRCode from 'qrcode'
import { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useApi } from '../../../api'
import { useProjectCode } from '../../../hooks/useProjectCode'
import { ICargo, IReferral } from '../../../interfaces';

export const ReferralPage = () => {
  const projectCode = useProjectCode();
  const api = useApi(projectCode);
  const toast = useToast();
  const [signupLink, setSignupLink] = useState<string>();
  const [signupQR, setSignupQR] = useState<string>();
  const [referral, setReferral] = useState<IReferral>();

  useEffect(() => {
    if (referral) return;
    api.getReferralCode((cargo: ICargo) => {
      const ref: IReferral = cargo.info;
      setReferral(ref)

    })
  }, [api, projectCode, referral, referral?.referralCode])

  useEffect(() => {
    setSignupLink(`${window.location.protocol}//${window.location.host}/store/${projectCode}/registration?referral=${referral?.referralCode}`)

  }, [projectCode, referral])

  useEffect(() => {
    if (!signupLink) return;
    QRCode.toDataURL(signupLink)
      .then(url => {
        setSignupQR(url);
      })
      .catch(err => {
        console.error(err)
      })
  }, [signupLink])

  return (
    <>
      <div className='text-center'>
        <Center>
          {signupQR && <img src={signupQR} alt={referral?.simpleCode} />}
        </Center>
        <div>{referral?.simpleCode}</div>
        <div className='p-3'><hr /></div>
        <div className='mb-3'>
          <CopyToClipboard text={signupLink || ''} onCopy={() => {
            toast({
              title: '推薦網址已複製',
              description: signupLink,
              position: 'bottom-right',
              status: 'success',
              duration: 9000,
              isClosable: true,
            })
          }}>
            <div className="text-xs text-gray-500">
              <div className='p-3'>{signupLink}</div>
              <Button variant={'outline'}>複製</Button>
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </>
  )
}